
import axios from '../../config/axiosConfig';
import { GET_INTREST_BILL_ADJUSTMENTS, SET_INTREST_BILL_ADJUSTMENTS, INTREST_BILL_ADJUSTMENT_REQUEST, INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, RESET_INTREST_BILL_ADJUSTMENTS } from '../types';

export const getIntrestBillAdjustments = (data, page, limit) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id, companyId: auth.company?.id, ...data, page, limit };
            return axios.get('/bill-intrest-adjustment/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_INTREST_BILL_ADJUSTMENTS, payload: response.data });
                } else {
                    dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Get Interest Bill Adjustments failed.' });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createIntrestBillAdjustments = (billAdjustment) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST });
            return axios.post('/bill-intrest-adjustment/add', billAdjustment,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}
            ).then((response) => {
                if (response.data) {
                    dispatch({ type: SET_INTREST_BILL_ADJUSTMENTS, payload: response.data });
                } else {
                    dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Interest Bill Adjustments create failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateIntrestBillAdjustments = (billAdjustment) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST });
            return axios.put('/bill-intrest-adjustment/update', billAdjustment,
                { params: { userId: auth.user?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: SET_INTREST_BILL_ADJUSTMENTS, payload: response.data });
                    } else {
                        dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: 'Interest Bill Adjustments update failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: INTREST_BILL_ADJUSTMENT_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const resetIntrestBillAdjustments = () => {
    return async (dispatch) => {
        dispatch({ type: RESET_INTREST_BILL_ADJUSTMENTS });
    };
};

export const setIntrestBillAdjustments = (data) => {
    return async (dispatch) => {
        dispatch({ type: SET_INTREST_BILL_ADJUSTMENTS, payload: data });
    };
};